import type { ListResponseTerm, AppSchemasTermTerm as Term } from "@classes-service-types/index.ts";
import type { UseQueryOptions } from "@tanstack/vue-query";
import { useQuery } from "@tanstack/vue-query";
import type { Ref } from "vue";

import { computed, unref } from "vue";
import termsService from "@/services/terms.js";

interface Args<TData = Term[]> {
  search?: Ref<string> | string;
  useQueryOptions?: Partial<UseQueryOptions<Term[], Error, TData>>;
}

export const useGetTermsData = <TData = Term[]>({ search, useQueryOptions }: Args<TData>) => {
  const fetchTerms = (): Promise<ListResponseTerm["data"]> =>
    termsService.list(unref(search) ?? "").then((val: { data: ListResponseTerm }) => val ?? []);

  return useQuery<Term[], Error, TData>({
    queryKey: computed(() => ["fetchTermsData", search]),
    queryFn: fetchTerms,
    ...useQueryOptions,
  });
};
